export default "__VITE_ASSET__BYKr123C__"